import { render, staticRenderFns } from "./Lesson.vue?vue&type=template&id=6e9481f3&scoped=true&"
import script from "./Lesson.vue?vue&type=script&lang=js&"
export * from "./Lesson.vue?vue&type=script&lang=js&"
import style0 from "./Lesson.vue?vue&type=style&index=0&id=6e9481f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9481f3",
  null
  
)

export default component.exports